import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "./PricingCards.css";
import AOS from "aos";

const PricingCards = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true, // Ensures animations run only once for better performance
    });
  }, []);
  const plans = [
    {
      title: "Basic Plan",
      price: "$30/month",
      features: [
        "Free Registration",
        "30 Minutes Class",
        "One to One Classes",
        "24/7 Classes",
        " 2 Classes in one week",
      ],
      link: "/Registration",
    },
    {
      title: "Pro Plan",
      price: "$35/month",
      features: [
        "Free Registration",
        "30 Minutes Class",
        "One to One Classes",
        "24/7 Classes",
        " 3 Classes in one week",
      ],
      link: "/Registration",
    },
    {
      title: "Enterprise Plan",
      price: "$50/month",
      features: [
        "Free Registration",
        "30 Minutes Class",
        "One to One Classes",
        "24/7 Classes",
        " 5 Classes in one week",
      ],
      link: "/Registration",
    },
  ];

  return (
    <>
      <h1 className="main-card-heading">Monthly Plan</h1>
      <div className="pricing-container">
        {plans.map((plan, index) => (
          <div key={index} className="pricing-card" data-aos="zoom-in">
            <h3 className="pricing-title">{plan.title}</h3>
            <p className="pricing-price">{plan.price}</p>
            <ul className="pricing-features">
              {plan.features.map((feature, idx) => (
                <li key={idx}>
                  {feature} <hr />
                </li>
              ))}
            </ul>
            <Link to={plan.link} className="pricing-button">
              Free Trial
              {/* Explore {plan.title} */}
            </Link>
          </div>
        ))}
      </div>
    </>
  );
};

export default PricingCards;
